module.exports = __webpack_public_path__ + "img/monitor3.65d478d8.jpg";